import { Component, OnInit } from '@angular/core';
import { ENUM_THEMES } from '../../../shared/helpers/app.constants';
import { ThemesSettingsService } from '../../../shared/services/themes-settings.service';

@Component({
  selector: 'app-upload-treatment',
  templateUrl: './upload-treatment.component.html',
  styleUrls: ['./upload-treatment.component.scss']
})
export class UploadTreatmentComponent implements OnInit {
  
  isDarkTheme: boolean;

  constructor(private themesSettingsService: ThemesSettingsService) {
    this.onCheckDarkThemes();
  }

  private onCheckDarkThemes(): void {
    const localData = this.themesSettingsService.getLocalStorage();
    if (localData && localData.themes === ENUM_THEMES.Dark) {
      this.isDarkTheme = true;
      if (document.body.classList.value.toString().indexOf('frac-dark-theme') === -1) document.body.classList.add('frac-dark-theme');
    } else {
      this.isDarkTheme = false;
      document.body.classList.remove('frac-dark-theme');
    }
  }

  ngOnInit() {
  }
}
